export default __webpack_public_path__ + "static/4-38a3661ffc057fbcae56a30687671e75.jpeg";